import "core-js/modules/es.error.cause.js";
import { computed, defineComponent } from "vue"; // modules

import ModalModule from "@/store/modules/modal"; // components

import PosConfiguration from "@/components/modal/PosConfiguration.vue";
import PCSelect from "@/components/modal/PCSelect.vue";
import Preferences from "@/components/modal/preferences/Preferences.vue";
import Products from "@/views/layout/components/footer/modal/Products.vue";
import Calculator from "@/components/modal/calculator/Calculator.vue";
import PaymentCalculator from "@/components/modal/payment-calculator/PaymentCalculator.vue";
import Settings from "@/components/modal/settings/Settings.vue";
import Analytics from "@/components/modal/Analytics.vue";
import Orders from "@/components/modal/orders/Orders.vue";
import Customers from "@/components/modal/customers/Customers.vue";
import CustomerCreate from "@/components/modal/customer-create/CustomerCreate.vue";
import CashierReports from "@/components/modal/cashier-reports/CashierReports.vue";
import CashFloatClose from "@/components/modal/CashFloatClose.vue";
import SendEmail from "../modal/SendEmail.vue";
import PaymentProgress from "@/components/modal/payment-progress/PaymentProgress.vue";
import EditCustomer from "@/components/modal/customers-edit/CustomerEdit.vue";
import DiscountSelectTickets from "@/components/modal/discount-select-tickets/DiscountSelectTickets.vue";
import AvailabilityInfo from "@/components/modal/quantity-not-available/AvailabilityInfo.vue";
import PrintTicketsAndReceipt from "@/components/modal/print-tickets-receipts/PrintTicketsReceipts.vue";
import DownloadTickets from "@/components/modal/DownloadTickets.vue";
import CustomFields from "@/components/modal/custom-fields/CustomFields.vue";
import CashFloatOpen from "@/components/modal/CashFloatOpen.vue";
import NewCashFloatOpen from "@/components/modal/new-cashfloat-open/NewCashFloatOpen.vue";
import CashInOut from "@/components/modal/cash-in-out/CashInOut.vue";
import ReloadConfiguration from "@/components/modal/ReloadConfig.vue";
import OccupancyCalendar from "@/components/modal/occupancy-calendar/OccupancyCalendar.vue";
import ScanQrCode from "@/components/modal/scan-qr-code/ScanQrCode.vue";
import Addons from "@/components/modal/addons/Addons.vue";
import PromocodeCampaignsModal from "@/components/modal/promocode/PromocodeCampaignsModal.vue";
import PromocodeCampaignsTicketsModal from "@/components/modal/promocode/PromocodeCampaignsTickets.vue";
import TabNameEditModal from "@/components/modal/tab-name/TabName.vue";
import PromocodeProcessing from "@/components/modal/promocode/PromocodeProcessing.vue"; // interfaces

import { ModalComponents, ModalStatus } from "@/constants/modal";
import BookingModule from "@/store/modules/booking";
import { BookingStep } from "@/constants/booking";
import { Currencies } from "@/constants/currency";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { roundToNearestMultipleOf5 } from "@/utils/helpers/common";
export default defineComponent({
  name: "Modal",
  components: {
    PosConfiguration: PosConfiguration,
    PCSelect: PCSelect,
    Preferences: Preferences,
    Products: Products,
    Calculator: Calculator,
    PaymentCalculator: PaymentCalculator,
    Settings: Settings,
    Analytics: Analytics,
    Orders: Orders,
    Customers: Customers,
    CustomerCreate: CustomerCreate,
    CashierReports: CashierReports,
    CashFloatClose: CashFloatClose,
    DiscountSelectTickets: DiscountSelectTickets,
    AvailabilityInfo: AvailabilityInfo,
    SendEmail: SendEmail,
    PrintTicketsAndReceipt: PrintTicketsAndReceipt,
    EditCustomer: EditCustomer,
    PaymentProgress: PaymentProgress,
    DownloadTickets: DownloadTickets,
    CustomFields: CustomFields,
    CashFloatOpen: CashFloatOpen,
    NewCashFloatOpen: NewCashFloatOpen,
    CashInOut: CashInOut,
    ReloadConfiguration: ReloadConfiguration,
    OccupancyCalendar: OccupancyCalendar,
    ScanQrCode: ScanQrCode,
    Addons: Addons,
    PromocodeCampaignsModal: PromocodeCampaignsModal,
    PromocodeCampaignsTicketsModal: PromocodeCampaignsTicketsModal,
    TabNameEditModal: TabNameEditModal,
    PromocodeProcessing: PromocodeProcessing
  },
  setup: function setup() {
    var status = computed(function () {
      return ModalModule.status;
    });
    var modalProps = computed(function () {
      return {
        modalProps: ModalModule.modalProps
      };
    });
    var selectedBooking = computed(function () {
      var booking = BookingModule.selectedBooking;

      if (!booking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      return booking;
    });

    function handleCapturedEvent(number, currency) {
      if (BookingModule.bookingStep === BookingStep.Payment) {
        if (number === 0) {
          // do not accept a payment of 0
          ModalModule.setStatus(ModalStatus.Hidden);
          return;
        }

        var paymentTool = BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID].paymentTool;
        BookingModule.addCurrentAmount({
          BookingUUID: BookingModule.selectedBookingUUID,
          amount: number
        }); // If we're in a booking that support split payment then we set the splitPaymentAmount here,
        // this split amount will have accountings created based on it, it shouldn't be more than what is left to pay for the booking

        if (BookingModule.doesSupportSplitPayment) {
          var roundedNumber;

          if (currency) {
            number = number * (1 / currency.exchangeRate); // if currency is not CHF we keep roundedAmount = amount for simplicity

            roundedNumber = number;

            if (selectedBooking.value.currency === Currencies.CHF) {
              roundedNumber = roundToNearestMultipleOf5(Math.round(number * 100)) / 100;
            }
          }

          BookingModule.setSplitPaymentAmount({
            BookingUUID: BookingModule.selectedBookingUUID,
            splitAmount: roundedNumber || number
            /*Math.min(
            amount,
            Math.abs(BookingModule.leftToPayAmount / 100)
            )*/
            ,
            splitAmountProvided: number
          });
        } // Hide modal


        ModalModule.setStatus(ModalStatus.Hidden);
      }

      if (BookingModule.bookingStep === BookingStep.Discount) {
        // Here we update the discount value
        BookingModule.updateDiscountValue({
          BookingUUID: BookingModule.selectedBookingUUID,
          value: number
        });
        ModalModule.setStatus(ModalStatus.Hidden);
      }
    }

    var modalComponent = computed(function () {
      if (status.value === ModalStatus.PosConfig) {
        return ModalComponents.POSConfig;
      }

      if (status.value === ModalStatus.PCSelect) {
        return ModalComponents.PCSelect;
      }

      if (status.value === ModalStatus.Preferences) {
        return ModalComponents.Preferences;
      }

      if (status.value === ModalStatus.Settings) {
        return ModalComponents.Settings;
      }

      if (status.value === ModalStatus.Calculator) {
        return ModalStatus.Calculator;
      }

      if (status.value === ModalStatus.PaymentCalculator) {
        return ModalStatus.PaymentCalculator;
      }

      if (status.value === ModalStatus.Orders) {
        return ModalStatus.Orders;
      }

      if (status.value === ModalStatus.Products) {
        return ModalStatus.Products;
      }

      if (status.value === ModalStatus.Customers) {
        return ModalStatus.Customers;
      }

      if (status.value === ModalStatus.Analytics) {
        return ModalStatus.Analytics;
      }

      if (status.value === ModalStatus.CustomerCreate) {
        return ModalStatus.CustomerCreate;
      }

      if (status.value === ModalStatus.CashierReports) {
        return ModalStatus.CashierReports;
      }

      if (status.value === ModalStatus.CashFloatClose) {
        return ModalStatus.CashFloatClose;
      }

      if (status.value === ModalStatus.DiscountSelectTickets) {
        return ModalStatus.DiscountSelectTickets;
      }

      if (status.value === ModalStatus.AvailabilityInfo) {
        return ModalStatus.AvailabilityInfo;
      }

      if (status.value === ModalStatus.SendEmail) {
        return ModalStatus.SendEmail;
      }

      if (status.value === ModalStatus.PrintTicketsAndReceipt) {
        return ModalStatus.PrintTicketsAndReceipt;
      }

      if (status.value === ModalStatus.PaymentProgress) {
        return ModalStatus.PaymentProgress;
      }

      if (status.value === ModalStatus.EditCustomer) {
        return ModalStatus.EditCustomer;
      }

      if (status.value === ModalStatus.DownloadTickets) {
        return ModalStatus.DownloadTickets;
      }

      if (status.value === ModalStatus.CustomFields) {
        return ModalStatus.CustomFields;
      }

      if (status.value === ModalStatus.CashFloatOpen) {
        return ModalStatus.CashFloatOpen;
      } // if (status.value === ModalStatus.NewCashFloatOpen) {
      //   return ModalStatus.NewCashFloatOpen;
      // }


      if (status.value === ModalStatus.CashInOut) {
        return ModalStatus.CashInOut;
      }

      if (status.value === ModalStatus.ReloadConfiguration) {
        return ModalStatus.ReloadConfiguration;
      }

      if (status.value === ModalStatus.OccupancyCalendar) {
        return ModalComponents.OccupancyCalendar;
      }

      if (status.value === ModalStatus.ScanQrCode) {
        return ModalStatus.ScanQrCode;
      }

      if (status.value === ModalStatus.Addons) {
        return ModalStatus.Addons;
      }

      if (status.value === ModalStatus.PromocodeCampaigns) {
        return ModalStatus.PromocodeCampaigns;
      }

      if (status.value === ModalStatus.PromocodeCampaignsTickets) {
        return ModalStatus.PromocodeCampaignsTickets;
      }

      if (status.value === ModalStatus.TabNameEdit) {
        return ModalStatus.TabNameEdit;
      }

      if (status.value === ModalStatus.PromocodeProcessing) {
        return ModalStatus.PromocodeProcessing;
      } // By default, hidden


      return null;
    });
    return {
      modalComponent: modalComponent,
      handleCapturedEvent: handleCapturedEvent,
      modalProps: modalProps
    };
  }
});